import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { location as LocationPreset, match as MatchPreset } from '../../../../Util/PropTypesPreset';
import VODList from './vodList';

const propTypes = {
  auth: PropTypes.object.isRequired,
  onClickCast: PropTypes.func,
  onClickProgram: PropTypes.func,
  onClickCategory: PropTypes.func,
  vodUpdate: PropTypes.func.isRequired,
  vodCastUpdate: PropTypes.func.isRequired,
  vodCategoryUpdate: PropTypes.func.isRequired,
  vodDetailUpdate: PropTypes.func.isRequired,
  location: PropTypes.shape(LocationPreset).isRequired,
  match: PropTypes.shape(MatchPreset).isRequired,
  loadVOD: PropTypes.bool,
  vodMain: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodCast: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodCate: PropTypes.arrayOf(PropTypes.object).isRequired,
  vodDetail: PropTypes.arrayOf(PropTypes.object).isRequired,
}

const defaultProps = {
  onClickCast: null,
  onClickProgram: null,
  onClickCategory: null,
  auth: {},
  vodUpdate: null,
  vodCastUpdate: null,
  vodCategoryUpdate: null,
  vodDetailUpdate: null,
  loadVOD: false,
  vodMain: [],
  vodCast: [],
  vodCate: [],
}

class VODPage extends React.Component<propTypes> {
  shouldComponentUpdate(nextProps) {
    const { location, loadVOD } = this.props
    const { location: LocationProps, loadVOD: LoadVODProps } = nextProps

    if (
      location.pathname !== LocationProps.pathname
      || loadVOD !== LoadVODProps
    ) {
      return true
    }
    return false
  }

  render() {
    const {
      auth,
      loadVOD,
      vodMain,
      vodCast,
      vodCate,
      vodDetail,
      vodUpdate,
      vodCastUpdate,
      vodCategoryUpdate,
      vodDetailUpdate,
      match,
      onClickCast,
      onClickProgram,
      onClickCategory,
    } = this.props

    return (
      <div id="vod-container">
        <Switch>
          <Route
            exact
            path={`${match.path}/vod/:id?`}
            render={() => {
              return (
                <VODList
                  onClickCast={onClickCast}
                  onClickProgram={onClickProgram}
                  onClickCategory={onClickCategory}
                  auth={auth}
                  vodUpdate={vodUpdate}
                  vodCastUpdate={vodCastUpdate}
                  vodCategoryUpdate={vodCategoryUpdate}
                  vodDetailUpdate={vodDetailUpdate}
                  loadVOD={loadVOD}
                  vodMain={vodMain}
                  vodCast={vodCast}
                  vodCate={vodCate}
                  vodDetail={vodDetail}
                  match={match}
                />
              );
            }}
          />
        </Switch>
      </div>
    )
  }
}

VODPage.propTypes = propTypes
VODPage.defaultProps = defaultProps

export default VODPage
